import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Luxurious Cushions. All rights reserved.</p>
        <div className="social-links">
          {/* Instagram Icon */}
          <a 
            href="https://www.instagram.com/cous.sindamour" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-icon"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>

          {/* WhatsApp Icon */}
          <a 
            href="https://wa.me/yourphonenumber" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-icon"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
